import {range} from "./index";

const CUR_ZONE_OFFSET_MINUTES = new Date().getTimezoneOffset()
const GMT_8_MILLIS_DELTA = (CUR_ZONE_OFFSET_MINUTES + 8 * 60) * 60 * 1000

function hoursMinutes(date){
    return date.getHours() * 100 + date.getMinutes()
}

function getOurDateFromGmt8(date){
    return new Date(date.getTime() - GMT_8_MILLIS_DELTA)
}

export function getThisDateAtGmt8(date){
    return new Date(date.getTime() + GMT_8_MILLIS_DELTA)
}

function getGmt8CurDate(){
    return getThisDateAtGmt8(new Date())
}

function gmt8CurTimeHM(){
    return hoursMinutes(getGmt8CurDate())
}

export function isTimeBeforeEvent(){
    const eventStart = new Date(2020, 11, 24, 18, 0, 0, 0)
    const eventStartInCurZone = getOurDateFromGmt8(eventStart)
    return Date.now() < eventStartInCurZone.getTime()
}

function inNext10Min(timeHM, fromHM){
    return timeHM >= fromHM && timeHM < fromHM + 10
}

function isIn10MinIntervals(timeHM, intervals){
    return intervals.some(i => inNext10Min(timeHM, i))
}

const events = [
    1800, 1810, 1820, 1830, 1840, 1850,
    1900, 1910, 1920, 1930, 1940, 1945,
    2015, 2055
];

export function getMillisToNextEvent(){
    const cur = gmt8CurTimeHM()
    const next = events.find(e => cur < e)
    return next ? next - cur : null
}

export function getCurrentTickerNumber(){
    const hmFormat = gmt8CurTimeHM()

    return 1;
}